import * as REAL from 'real_api_bbl';

export default class R3DExporter {
  constructor() {}
  async export(scene, onProgress, onError, ignoreList = undefined) {
    return await REAL.Scene(scene, undefined, onProgress, onError, ignoreList);
  }
}
